import React, { Component } from 'react';
import {
    InputGroup, InputGroupAddon, InputGroupText,
    Input, Row, Col, Form, Button, FormGroup
} from 'reactstrap';
import { SendingEmail } from '../../../../redux/Action/fogoetpassword';
import { Field, reduxForm } from 'redux-form';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import validate from './validation';
import EmailBool from '../forgetPassword/forgetPassword'

const renderField = ({ input, type, icone, meta: { touched, error, warning } }) => (
    <div>
        <InputGroup>
            <Input {...input} placeholder="Tech4Life@gmail.com" type={type} style={{ width: "80%", margin: "auto" }} />
            <InputGroupAddon addonType="prepend">
                <InputGroupText>
                    <i className={icone}></i>
                </InputGroupText>
            </InputGroupAddon>
        </InputGroup >
        <div>
            {touched && ((error && <span className="erroMSG" > {error}</span>))}
        </div>
    </div>
)

class SendEmail extends Component {

    constructor() {
        super();
        this.state = {
            selectedOption: 'admin'
        };
        this.radioChange = this.radioChange.bind(this);
    }

    radioChange(e) {
        this.props.handlecheck(e.currentTarget.value === "admin" ? "ADMIN" : "SUB_ADMIN")
        this.setState({
            selectedOption: e.currentTarget.value
        });
    }

    onSubmit = (values) => {
        values.type = this.state.selectedOption === "admin" ? "ADMIN" : "SUB_ADMIN"
        
        console.log("selectedOption", values.type)
        this.props.SendingEmail(values)
       
    }


    render() {

        const { handleSubmit, submitting } = this.props;

        return (
            <div>

                <Row>
                    <Col lg="12">
                        <h2 className="mb-3">البريد الالكتروني</h2>
                    </Col>

                    <Col lg="10" className="m-auto">
                        <Form onSubmit={handleSubmit(this.onSubmit.bind(this))}>
                            <FormGroup>
                                <Field type="email" name="email" component={renderField} icone="fa fa-envelope-open" />
                            </FormGroup>
                            <Row className="text-right LoginType">
                                <Col lg="12">
                                    <h4>نوع المستخدم</h4>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <input type="radio" id="admin" name="typelogin" value="admin" checked={this.state.selectedOption === "admin"}
                                            onChange={this.radioChange} />
                                        <label className="mr-3" style={{ color: "rgb(15, 104, 159)" }}>ادمن</label>
                                    </FormGroup>
                                </Col>
                                <Col>
                                    <FormGroup>
                                        <input type="radio" id="subadmin" name="typelogin" value="subadmin" checked={this.state.selectedOption === "subadmin"}
                                            onChange={this.radioChange} />
                                        <label className="mr-3" style={{ color: "rgb(15, 104, 159)" }}>مسئول</label>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div className="pb-4 pt-2">
                                <Button disabled={submitting}>تاكيد</Button>
                            </div>
                        </Form>
                    </Col>
                </Row>



            </div>
        )
    }
}

const mapStateToProps = state => {
    return {
    }
}
const mapDispatchToProps = dispatch => bindActionCreators(
    {
        SendingEmail,
    }
    , dispatch
)

export default reduxForm({
    form: 'fieldLevelValidation', // a unique identifier for this form
    validate
})(connect(mapStateToProps, mapDispatchToProps, EmailBool)(SendEmail));
